import { render, staticRenderFns } from "./SimpleIndex.vue?vue&type=template&id=6160bef2&scoped=true&"
import script from "./SimpleIndex.vue?vue&type=script&lang=ts&"
export * from "./SimpleIndex.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleIndex.vue?vue&type=style&index=0&id=6160bef2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6160bef2",
  null
  
)

export default component.exports